module.exports = __webpack_public_path__ + "img/logo-txt.031040f2.png";